// if you wrap m in curly braces, the code fails silently
// import m from 'mithril/mithril.min.js'; // this also works
// from https://mithril.js.org/installation.html
import m from 'mithril';
// require doesn't work either
// var m = require("mithril");
// import { customDate, customTime } from './util.js';

// gui.cssgrid is broken at the moment, rebuild a smaller MVP for mithril and css grid
import { splash4444 } from './gui.cssgrid/breathe/splash4444.js';
import { splash478 } from './gui.cssgrid/breathe/splash478.js';

function mountMithril() {
  var root = document.getElementById('mithrilSpace');
  m.route(root, `/`, {
    "/": splash4444,
    "/4444": splash4444,
    "/478": splash478,
  });
}

export { mountMithril };
